import { fullpageInit, fullpageLoader } from '../modules/fullpage-handler';
import { scrollToAnchor } from '../modules/anchor';

const initialize = () => {
    // Preloader for fullpage.js (show loader on pages where fullpage is provided)
    fullpageLoader();

document.addEventListener("DOMContentLoaded", function(){
        // Initialize fullpage.js for pages where it's needed
        let viewportWidth;
        let fullpageActive = false;

        let setViewportWidth = function () {
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        };

        let logWidth = function () {
            if (viewportWidth > 767 && !fullpageActive) {
                fullpageInit();
                let fullpageActive = true;
            } else {
                scrollToAnchor();
            }
        };

        setViewportWidth();
        logWidth();

        window.addEventListener('resize', function () {
            setViewportWidth();
            if (fullpageActive) {
                $.fn.fullpage.destroy('all');
                let fullpageActive = false;
            }
        }, false);
    });
};

export default initialize;
